<template>
  <div>
    <v-select
      v-model="selected"
      @search="searchWarehouse"
      style="w-100"
      :options="warehouses"
      @input="addProduct"
      :getOptionLabel="(option) => option.name"
      :close-on-select="true"
      :autoscroll="true"
      placeholder="Select Warehouse"
    ></v-select>
  </div>
</template>
<script>
import Warehouse from "@/mixins/Warehouse";
export default {
  name: "Select Warehouse",
  mixins: [Warehouse],
  data: () => ({
    selected: null,
  }),
  methods: {
    searchWarehouse() {},
    addProduct() {},
    warehouses() {},
  },
};
</script>
